import ArrowBigRight from '@/assets/icon/minimap/ArrowBigRight';
import { body3, palette } from '@/modules/defines/styles';
import { Fragment } from 'react/jsx-runtime';
import styled from 'styled-components';

interface ChipProps {
  matchedFloor: string[];
}
const Chip = ({ matchedFloor }: ChipProps) => {
  if (matchedFloor.length === 0) return null;
  return (
    <Wrapper>
      {matchedFloor.map((item, index, array) => (
        <Fragment key={index}>
          {item}
          {index !== array.length - 1 && (
            <ArrowBigRight fill={palette.secondaryRed700} />
          )}
        </Fragment>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  height: 2.25rem;
  min-width: 0;
  max-width: 80vw;
  ${body3};
  color: ${palette.gray700};
  padding: 0.4375rem 0.75rem;
  border-radius: 100px;
  background: white;
  border: 1px solid ${palette.gray500};
  white-space: nowrap;
  overflow: hidden;
`;
export default Chip;
